var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTabSubscription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M933.63,0H90.41C40.48,0,0,40.48,0,90.41v854.93c0,42.19,33.26,76.87,75.41,78.64,2.05.1,4.09-.32,5.92-1.23l382.51-195.61c29.48-15.07,64.4-15.11,93.92-.11l384.97,195.7c1.83.91,3.86,1.33,5.9,1.23,42.15-1.76,75.41-36.43,75.43-78.62V90.41C1024.05,40.48,983.57,0,933.63,0ZM662.81,658.6l-142.72-103.67c-4.89-3.55-11.52-3.55-16.41,0l-142.72,103.67c-5.24,3.8-12.56,2.63-16.36-2.6-2.2-3.03-2.82-6.93-1.66-10.49l54.51-167.78c1.86-5.75-.19-12.04-5.07-15.6l-142.72-103.67c-5.23-3.8-6.4-11.12-2.6-16.36,2.2-3.04,5.73-4.83,9.48-4.83h176.41c6.05,0,11.4-3.89,13.27-9.64l54.55-167.79c1.99-6.15,8.59-9.53,14.75-7.54,3.58,1.16,6.39,3.96,7.54,7.54l54.48,167.77c1.87,5.77,7.26,9.67,13.33,9.64h176.35c6.47,0,11.71,5.24,11.72,11.71,0,3.75-1.79,7.28-4.83,9.48l-142.72,103.67c-4.89,3.56-6.93,9.85-5.07,15.6l54.51,167.84c1.97,6.16-1.43,12.75-7.59,14.72-3.54,1.13-7.41.51-10.43-1.67h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTabSubscription);
export default __webpack_public_path__ + "static/media/member-tab-subscription.d7816e457d69a8c154044919a63b878f.svg";
export { ForwardRef as ReactComponent };